const buildPipelineParams = pipeline => {
  if (!pipeline) {
    return {};
  }

  return { pipeline };
};

const buildServiceOrderFilterParams = filters => {
  if (!filters) {
    return {};
  }

  return Object.entries(filters).reduce((acc, [key, value]) => {
    if (value === undefined || value === null || value === '') {
      return acc;
    }

    acc[key] = value;
    return acc;
  }, {});
};

export const getColumns = async (accountId, pipeline) => {
  const response = await window.axios.get(
    `/api/v1/accounts/${accountId}/crm/kanban_columns`,
    {
      params: buildPipelineParams(pipeline),
    }
  );
  return response;
};

export const getServiceOrders = async (
  accountId,
  { pipeline, filters } = {}
) => {
  const response = await window.axios.get(
    `/api/v1/accounts/${accountId}/crm/service_orders`,
    {
      params: {
        ...buildPipelineParams(pipeline),
        ...buildServiceOrderFilterParams(filters),
      },
    }
  );
  return response;
};

export const updateServiceOrder = async (
  accountId,
  orderId,
  payload,
  pipeline
) => {
  const response = await window.axios.put(
    `/api/v1/accounts/${accountId}/crm/service_orders/${orderId}`,
    { service_order: payload },
    { params: buildPipelineParams(pipeline) }
  );
  return response;
};

export const createServiceOrder = async (accountId, payload, pipeline) => {
  const response = await window.axios.post(
    `/api/v1/accounts/${accountId}/crm/service_orders`,
    { service_order: payload },
    { params: buildPipelineParams(pipeline) }
  );
  return response;
};

export const deleteServiceOrder = async (accountId, orderId, pipeline) => {
  const response = await window.axios.delete(
    `/api/v1/accounts/${accountId}/crm/service_orders/${orderId}`,
    { params: buildPipelineParams(pipeline) }
  );
  return response;
};

export const createColumn = async (accountId, payload, pipeline) => {
  const response = await window.axios.post(
    `/api/v1/accounts/${accountId}/crm/kanban_columns`,
    { kanban_column: payload },
    { params: buildPipelineParams(pipeline) }
  );
  return response;
};

export const updateColumn = async (accountId, columnId, payload, pipeline) => {
  const response = await window.axios.patch(
    `/api/v1/accounts/${accountId}/crm/kanban_columns/${columnId}`,
    { kanban_column: payload },
    { params: buildPipelineParams(pipeline) }
  );
  return response;
};

export const deleteColumn = async (accountId, columnId, pipeline) => {
  const response = await window.axios.delete(
    `/api/v1/accounts/${accountId}/crm/kanban_columns/${columnId}`,
    { params: buildPipelineParams(pipeline) }
  );
  return response;
};

// Default export for backward compatibility with useCrmStore
export default {
  getColumns,
  getServiceOrders,
  updateServiceOrder,
  createServiceOrder,
  deleteServiceOrder,
  createColumn,
  updateColumn,
  deleteColumn,
};
